import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfilePageRoutingModule } from './profile-routing.module';

import { ProfilePage } from './profile.page';
import { SharedModule } from 'src/app/core/modules/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileDetailComponent } from './components/profile-detail/profile-detail.component';
import { FaqComponent } from './components/faq/faq.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UnitPreferenceModule } from 'src/app/core/modules/unit-preferences.module';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationDetailsComponent } from './components/notification-details/notification-details.component';
import { ErrorLogSaveComponent } from './components/error-log-save/error-log-save.component';
import { ErrorLogsListComponent } from './components/error-logs-list/error-logs-list.component';
import { SupportComponent } from './components/support/support.component';
import { AskExpertListComponent } from './components/ask-expert-list/ask-expert-list.component';
import { AskExpertSaveComponent } from './components/ask-expert-save/ask-expert-save.component';
import { MyDevicesComponent } from './components/my-devices/my-devices.component';
import { DeviceDetailComponent } from './components/device-detail/device-detail.component';
import { PhotoCaptureTimeComponent } from './components/photo-capture-time/photo-capture-time.component';
import { TrainingRequestComponent } from './components/training-request/training-request.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LocationInfoComponent } from './components/location-info/location-info.component';
import { UserManualComponent } from './components/user-manual/user-manual.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProfilePageRoutingModule,
    SharedModule,
    TranslateModule,
    UnitPreferenceModule,
    ReactiveFormsModule,
    PdfViewerModule
  ],
  declarations: [
    ProfilePage,
    ProfileDetailComponent,
    FaqComponent,
    SettingsComponent,
    NotificationsComponent,
    NotificationDetailsComponent,
    ErrorLogSaveComponent,
    ErrorLogsListComponent,
    SupportComponent,
    AskExpertListComponent,
    AskExpertSaveComponent,
    MyDevicesComponent,
    DeviceDetailComponent,
    PhotoCaptureTimeComponent,
    TrainingRequestComponent,
    UserManualComponent,
    LocationInfoComponent]
})
export class ProfilePageModule { }
